import { SCREEN } from 'const';

export const adminNav = [
  { title: 'Thông tin', screen: SCREEN.AdminInfo },
  { title: 'Quy ước', screen: SCREEN.AdminQuyUoc },
  { title: 'Đơn hàng', screen: SCREEN.AdminOrder, params: { limit: 20 } },
  { title: 'Tiền seri', screen: SCREEN.AdminMoney },
  { title: 'Bộ sưu tập', screen: SCREEN.AdminCollections },
  { title: 'Thống kê', screen: SCREEN.AdminStatistics },
];